module.exports = __webpack_public_path__ + "img/dz1.0-1.8e3c5a86.jpg";